import React from "react";

export function ModuleHeader({ eyebrow, title, subtitle, actions }) {
    return (
        <div className="flex flex-wrap items-end justify-between gap-4 pb-6 mb-8 border-b border-brand-line admin-fade">
            <div>
                {eyebrow && <p className="text-[11px] uppercase tracking-[0.25em] text-brand-gold">{eyebrow}</p>}
                <h1 data-testid="admin-module-title" className="font-display text-3xl sm:text-4xl mt-1">{title}</h1>
                {subtitle && <p className="text-sm text-brand-mute mt-2 max-w-2xl">{subtitle}</p>}
            </div>
            {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
        </div>
    );
}

export function StatCard({ label, value, hint, testId, accent = false }) {
    return (
        <div
            data-testid={testId}
            className={`p-5 rounded-sm border bg-brand-charcoal transition-colors hover:border-brand-gold/60 ${
                accent ? "border-brand-gold/50" : "border-brand-line"
            }`}
        >
            <p className="text-[11px] uppercase tracking-[0.2em] text-brand-mute">{label}</p>
            <p className="font-display text-3xl mt-2 text-brand-cream">{value}</p>
            {hint && <p className="text-xs text-brand-mute mt-1">{hint}</p>}
        </div>
    );
}

const PILL = {
    new: "bg-brand-gold/15 text-brand-gold border-brand-gold/40",
    in_progress: "bg-sky-500/10 text-sky-300 border-sky-500/30",
    fulfilled: "bg-brand-olive/20 text-[#A9C46C] border-brand-olive/50",
    done: "bg-white/5 text-brand-cream/70 border-brand-line",
    cancelled: "bg-red-500/10 text-red-300 border-red-500/30",
};

export function StatusPill({ status, label }) {
    return (
        <span className={`text-[10px] uppercase tracking-[0.15em] px-2 py-1 border rounded-sm ${PILL[status] || PILL.done}`}>
            {label}
        </span>
    );
}

export function EmptyState({ children }) {
    return (
        <div className="border border-dashed border-brand-line p-12 text-center text-brand-mute rounded-sm text-sm">
            {children}
        </div>
    );
}
